import sendLocalRequest from "./sendLocalRequest";

export const changePassword = (auth_token,
                                username,
                                old_password,
                                new_password
                                ) => {

    const data = {
        "username":  username,
        "old_password": old_password,
        "new_password":  new_password
    }

    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`change_password`, "POST", auth_token, data).then( (data) => {
            resolve(data);
        }).catch( (error_code) => {
            reject(error_code);
        })
    });
};
